export default __webpack_public_path__ + "static/media/hht1_ep09_timeline_q03_b.8ba3c2b1.png";